import { z } from "zod"

export interface OnboardingWatchedStatus {
  slug: string
}

export const SetOnboardingWatchedSchema = z.object({
  isWatched: z.boolean(),
})

export type SetOnboardingWatched = z.infer<typeof SetOnboardingWatchedSchema>
